import * as api from '@/http'

export const ActionSetDepartments = async ({ commit }) => {
  const departments = await api.http.get('dash/departments').then(
    (response) => response.body,
    (error) => error
  )
  commit('SET_departments', departments)
}
